import { subscribeMercureRefresh } from '../../utils/mercureRefresh'
import { Controller } from '@hotwired/stimulus'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'

const IssueEventType = {
  drone_update: 'droneUpdate'
}

export default class extends Controller {
  static values = {
    url: String
  }

  connect () {
    this.refresh = subscribeMercureRefresh(
      data => this.shouldRefresh(data),
      context => this.reloadDetectionComponent(context)
    )
    this.refresh.request()
  }

  disconnect () {
    this.refresh.dispose()
  }

  shouldRefresh ({ eventType }) {
    return eventType === IssueEventType.drone_update
  }

  async reloadDetectionComponent ({ isCurrent }) {
    const response = await fetchWithHandlingLoginRedirect(this.urlValue, {
      method: 'GET',
      reloadOnNetworkError: false
    })

    const data = await response.json()
    if (!isCurrent()) return

    const parser = new DOMParser()
    const doc = parser.parseFromString(data.component, 'text/html')

    const newImg = doc.querySelector('#detection-image')
    const newMapContainer = doc.querySelector('#detection-map-container')
    const currentMapContainer = this.element.querySelector('#detection-map-container')
    const currentImg = this.element.querySelector('#detection-image')
    if (newMapContainer && currentMapContainer) {
      if (newImg?.src) {
        await this.preloadImage(newImg.src)
        if (!isCurrent()) return
      }
      if (currentImg && newImg?.src) {
        currentImg.src = newImg.src
      } else {
        currentMapContainer.innerHTML = newMapContainer.innerHTML
      }
    }

    const newInfoEl = doc.querySelector('#detection-info')
    const currentInfo = this.element.querySelector('#detection-info')
    if (newInfoEl && currentInfo) currentInfo.innerHTML = newInfoEl.innerHTML
  }

  preloadImage (url) {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = resolve
      img.onerror = reject
      img.src = url
    })
  }
}
